<template>
    <div id="loader" class="loader-overlay" :class="{ 'is-hidden': ! visible }">
        <div class="lds-ripple"><div></div><div></div></div>
    </div>
</template>

<script>
    export default {
        props: {
        	visible: { default: false },
        }
    }
</script>
